exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-card__header{border-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2dff0969!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/UserManager.vue
// module id = 576
// module chunks = 2